import { produce } from 'immer';
import { Reducer } from 'redux';

import { BucketUndefined, Upload, UploadDTO } from '@/controllers/Uploads';

import { UploadsQueueActionTypes } from './action-types';

export const uploadsQueueReducer: Reducer<Upload[] | UploadDTO[]> = (
  state = [],
  action,
): UploadDTO[] => {
  const { type, payload } = action;

  switch (type) {
    case UploadsQueueActionTypes.ADD_UPLOADS_TO_THE_UPLOADING_QUEUE:
      return [...state, ...payload];

    case UploadsQueueActionTypes.CANCEL_ALL_UPLOADS:
      return [];

    case UploadsQueueActionTypes.REMOVE_FROM_UPLOADING_QUEUE_BY_BUCKET_ID:
      return (state as UploadDTO[]).filter(item => item.bucketId !== payload);

    case UploadsQueueActionTypes.CHANGE_UPLOAD_STATUS_TO_IN_PROGRESS:
    case UploadsQueueActionTypes.CHANGE_UPLOAD_STATUS_TO_SUCCEED:
    case UploadsQueueActionTypes.CHANGE_UPLOAD_STATUS_TO_CANCELED:
    case UploadsQueueActionTypes.CHANGE_UPLOAD_STATUS_TO_FAILED:
      return state.map(item => {
        if (item.id === payload.id) {
          const result = {
            ...item,
            uploadStatus: payload.uploadStatus,
          };

          if (payload.error) {
            result.error = payload.error;
          }

          return result;
        }

        return item;
      });

    case UploadsQueueActionTypes.UPDATE_UPLOADS_BUCKET_NAME:
      return produce(state, (nextState: UploadDTO[]) => {
        state.forEach((upload, index) => {
          if (upload.bucketId === BucketUndefined) {
            nextState[index].bucketId = payload.bucketId;
          }
        });
      }) as UploadDTO[];

    default:
      return state as UploadDTO[];
  }
};
